import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import liff from '@line/liff';

import { callPost } from '../ajax/server';
import { InitAction } from '../store/init/action';
import { getConfig } from '../config/global';
import { trackVisit } from '../logger/googleAnalytics';
import { RegisterPath, DisclaimerLiveAgentPath, OtpPath, SurveyPath, SurveyThankyouPath, PrivacyNoticePath } from '../path/path';

import Disclaimer from '../pages/disclaimer/disclaimer';
import PageNotFound from '../pages/pageNotFound/pageNotFound';
import Loading from '../pages/loading/loading';
import NotMobileError from '../pages/notMobileError/notMobileError';
import Register from '../pages/register/register';
import DisclaimerLiveAgent from '../pages/disclaimer/disclaimerLiveAgent';
import Otp from '../pages/register/otp';
import SurveyContainer from './survey/surveyContainer';
import SurveyThankyou from './survey/surveyThankyou';
import PrivacyNotice from './privacyNotice/privacyNotice';

interface AppProps {
    language: string;
    isReady: boolean;

    setInitial: (userStatus: number, translations: {[key: number]: string}) => void;
    setLiffReady: (userId: string, name: string, lineLiffId: string) => void;
};

class App extends React.Component<AppProps> {
    public componentDidMount() {
        // TODO: GET Channal ID HERE (use LIFF functions)***
        liff.init({ liffId: getConfig().liffId }).then(() => {
            if (liff.isInClient()) {
                liff.getProfile().then((profile) => {
                    this.props.setLiffReady(profile.userId, profile.displayName, getConfig().liffId);

                    callPost('/easyInvestConnectWebsite/api/init', { userId: profile.userId, language: this.props.language }, (data: any) => {
                        const res = JSON.parse(data);
                        
                        this.props.setInitial(res['userStatus'], res['translations']);
                    });
                });
            } else {
                // TODO: LIFF condition (Unmark)
                // this.props.setLiffReady('', '', '');
                // callPost('/easyInvestConnectWebsite/api/init', { userId: 'unknown', language: this.props.language }, (data: any) => {
                //     const res = JSON.parse(data);
                    
                //     this.props.setInitial(res['userStatus'], res['translations']);
                // });
            }
        });

        trackVisit('landing');
    }

    public render() {
        if (!this.props.isReady) {
            return <Loading />;
        }

        // TODO: LIFF condition (Remark)
        if (!liff.isInClient()) {
            return <NotMobileError />;
        }

        return (
            <BrowserRouter>
                <Switch>
                    {/* <Route exact path='/disclaimer'>
                        <Disclaimer isInfoOnly={false} />
                    </Route> */}
                    <Route exact path='/'>
                        <Disclaimer isInfoOnly={false} />
                    </Route>
                    {/* <Route exact path='/disclaimerinfo'>
                        <Disclaimer isInfoOnly={true} />
                    </Route>
                    <Route exact path={RegisterPath} component={Register} />
                    <Route exact path={DisclaimerLiveAgentPath} component={DisclaimerLiveAgent} />
                    <Route exact path={OtpPath} component={Otp} />
                    <Route exact path={SurveyPath} component={SurveyContainer} />
                    <Route exact path={SurveyThankyouPath} component={SurveyThankyou} />
                    <Route exact path={PrivacyNoticePath} component={PrivacyNotice} /> */}
                    <Route component={PageNotFound}></Route>
                </Switch>
            </BrowserRouter>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        language: state.initReducer.language,

        // TODO: LIFF condition (Remark)
        isReady: state.initReducer.ready && state.initReducer.liffReady,

        // TODO: LIFF condition (Unmark)
        // isReady: state.initReducer.ready, // uncomment this line for dev testing
    };
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        setInitial: (userStatus: number, translations: {[key: number]: string}): void => dispatch({ type: InitAction.SetInitial, value: { userStatus, translations }}),
        setLiffReady: (userId: string, name: string, lineLiffId: string): void => dispatch({ type: InitAction.SetLiffReady, value: { userId, name, lineLiffId }}),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
export const AppComponent = App;